<template>
  <d-container fluid class="main-content-container px-4">

    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle d-block">Material</span>
        <h3 class="page-title">{{ material.id ? 'Editar' : 'Adicionar' }}</h3>
        <button v-if="material.id" class="btn btn-success text-white float-right" @click="newMaterial">Novo material</button>
        <d-button type="button" @click.prevent="save" class="btn-accent float-right mr-2">Salvar</d-button>
      </d-col>
    </d-row>

    <!-- Content -->
    <d-row>
      <!-- Editor -->
      <d-col lg="12" class="mb-4">
        <d-card class="card-small">

          <!-- Form Example -->
          <d-card-header class="border-bottom">
            <h6 class="m-0">Dados cadastrais</h6>
          </d-card-header>

          <d-list-group flush>
            <d-list-group-item class="p-3">
              <material-form ref="materialForm"/>
            </d-list-group-item>
          </d-list-group>
        </d-card>
      </d-col>

    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import MaterialService from '_services/rest/modules/material';
import { MODEL, _LOAD_MODEL_, _SAVE_MATERIAL_SUCCESS_ } from '../components/MaterialModel';
import MaterialForm from '../components/MaterialForm.vue';

export default {
  name: 'material-page',
  components: {
    MaterialForm,
    MaterialService,
  },
  computed: {
    material() {
      const { materialEdit } = this.$store.state.material;
      if (materialEdit) {
        Events.$emit(_LOAD_MODEL_, materialEdit);
        return materialEdit;
      }
      return MODEL;
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getMaterial',
    ]),
    getMaterialModel() {
      this.getMaterial(parseInt(this.$route.params.materialId, Number));
    },
    newMaterial() {
      this.$store.commit('setMaterial', MODEL);
      this.$router.push({ name: 'admin-material-new' });
    },
    save() {
      this.$refs.materialForm.save();
      Events.$on(_SAVE_MATERIAL_SUCCESS_, material => {
        this.$router.push({ name: 'admin-material-edit', params: { materialId: material.id } }).catch(() => { });
      });
    },
  },

  mounted() {
    if (this.$route.params.materialId) {
      this.getMaterialModel();
    }
  },
};
</script>

